/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { map } from "lodash";
import { createFragmentContainer } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import Pill from "../Pill";

import SectionAccordion from "./SectionAccordion";
import { SectionModal } from "../../modals/SectionModal";

function SectionsList(props) {
  const t = useTranslation();
  const {
    recipe: { section },
    recipeId,
    recipeName,
    allIngredients,
    allUnitMeasure,
    refetchData,
  } = props;

  return (
    <div className="pills sections-list">
      {map(section?.edges, (sectIngredients) => {
        if (sectIngredients?.node?.name !== "null") {
          return (
            <SectionAccordion
              key={sectIngredients?.node?.name}
              recipeId={recipeId}
              recipeName={recipeName}
              section={{
                id: sectIngredients?.node?.id,
                name: sectIngredients?.node?.name,
                comments: sectIngredients?.node?.comments,
                ingredients: sectIngredients?.node?.recipeingredientSet?.edges,
              }}
              sectionId={sectIngredients?.node?.id}
              allIngredients={allIngredients}
              allUnitMeasure={allUnitMeasure}
              refetchData={refetchData}
            />
          );
        }
      })}

      <SectionModal
        recipeId={recipeId}
        refetchData={refetchData}
        trigger={
          <span>
            <Pill newItem text={t("pill.addSection")} />
          </span>
        }
      />
    </div>
  );
}

export default createFragmentContainer(SectionsList, {
  recipe: graphql`
    fragment SectionsList_recipe on RecipeNode {
      section(first: null)
      @connection(key: "SectionsList_section", filters: []) {
        edges {
          node {
            id
            name
            recipe {
              name
            }
            recipeingredientSet {
              edges {
                node {
                  id
                  comments
                  ingredient {
                    name
                    id
                  }
                  unityF {
                    id
                  }
                  unity
                  qty
                }
              }
            }
          }
        }
      }
    }
  `,
});
